import { useQuery } from "@tanstack/react-query";
import { COINGECKO } from "../constants/api.constants";

export interface IADAData {
  cardano: {
    last_updated_at: number;
    usd: number;
    usd_24h_change: number;
    usd_24h_vol: number;
    usd_market_cap: number;
  };
}

export const useAdaData = () =>
  useQuery(
    ["adaData"],
    () =>
      fetch(
        `${COINGECKO}/simple/price?ids=cardano&vs_currencies=usd&include_24hr_change=true&include_last_updated_at=true&include_24hr_vol=true&include_market_cap=true`
      )
        .then((res) => res.json())
        .then((json: IADAData) => {
          return {
            ...json.cardano,
            usd: json.cardano.usd ?? 0,
          };
        }),
    {
      staleTime: 1000 * 60 * 10,
      refetchOnWindowFocus: false,
    }
  );
